/**
 * Guest routes: routes that do not need authentication
 * (login, welcome etc).
 *
 * Will me merged into the router's 'route' array
 */

import Welcome from '@/views/guest/default-customer/Welcome.vue'
import WelcomeTG from '@/views/guest/tg/Welcome.vue'
import WelcomeSH from '@/views/guest/sh/Welcome.vue'
import type { Component } from 'vue'
import Login from '@/views/guest/Login.vue'
import { useGlobals } from '@/helpers/globals'
import Register from '@/views/guest/Register.vue'
import Reset from '@/views/guest/Reset.vue'
import Activate from '@/views/guest/Activate.vue'

const componentMap: Record<string, Record<string, Component>> = {
    default: {
        welcome: Welcome,
    },
    sh: {
        welcome: WelcomeSH,
    },
    tg: {
        welcome: WelcomeTG,
    },
}

export default [
    {
        path: '/welcome',
        name: 'welcome',
        component: () =>
            new Promise((success) => {
                success(componentMap[useGlobals().customer].welcome)
            }),
        meta: {
            guest: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            guest: true,
            title: 'Anmelden',
        },
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            guest: true,
            title: 'Registrieren',
        },
    },
    {
        path: '/activate',
        name: 'activate',
        component: Activate,
        meta: {
            guest: true,
            title: 'Aktivieren',
        },
    },
    {
        path: '/reset',
        name: 'reset',
        component: Reset,
        meta: {
            guest: true,
        },
    },
]
